import React from 'react';
import {Flex, Hint, TextInput} from '/app/src/component';

export default ({entry, ...rest }) => {
    if(!entry)
        return null
    const responseType = entry.meta.details.type;
    const respondData = entry.meta.details.respond_data;

    let email = 'email';
    let message = ' Vi svarar så fort vi kan, har du inte tid att vänta kan du skriva in din e-mail så återkommer vi!'

    if(respondData){
        email = respondData.email;
    }

    switch(responseType){
        case 'email_not_exist':
        default:
            message = 'Vi svarar så fort vi kan. Har du inte tid att vänta så kan du skriva din e-mail nedan så återkommer vi!'
            break;

    }

    return (
        <Flex hAlignContent='center' bg='#f0f0f0' basis='370px' minh='62px' borderRadius='20px' padding='15px' shrink color='black' my='15px' position='relative'>
                <Hint style={{position: 'absolute', right: '5px', top: '5px', zIndex: '1'}}
                 position='top-end' tooltip='Kolla om personen fortfarande är online. Annars välj "Skicka som e-mail" i högerpanelen efter du svarat i chatten eller kopiera mailadressen och återkoppla via e-mail manuellt.'/>
            <Flex vAlignContent='center' fontSize='14px' column position='relative'>
                <Flex padding='5px'>
                    {message}
                </Flex>
                <Flex vAlignContent='center' marginBottom='10px'>
                    <TextInput placeholder='E-mail' disabled value={email} name='displayName'/>
                </Flex>
            </Flex>
        </Flex>
    )
}



// WEBPACK FOOTER //
// ./src/component/Conversation/Message/_MetaAutoresponse.js